// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-physical-build .survey-option,
.page-dream-body .survey-option,
.page-areas-to-focus .survey-option,
.page-struggle .survey-option {
  padding: 0 16px 0 6px;
}

.page-physical-build .survey-option img,
.page-dream-body .survey-option img,
.page-areas-to-focus .survey-option img,
.page-struggle .survey-option img {
  width: 92px;
  height: 92px;
  margin-right: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/physical.css"],"names":[],"mappings":"AAAA;;;;EAIE,qBAAqB;AACvB;;AAEA;;;;EAIE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".page-physical-build .survey-option,\n.page-dream-body .survey-option,\n.page-areas-to-focus .survey-option,\n.page-struggle .survey-option {\n  padding: 0 16px 0 6px;\n}\n\n.page-physical-build .survey-option img,\n.page-dream-body .survey-option img,\n.page-areas-to-focus .survey-option img,\n.page-struggle .survey-option img {\n  width: 92px;\n  height: 92px;\n  margin-right: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
